
import { 
    postData, getDataWithParams
} from '@/store/api/method'



const initialState = () => ({
    msg: null,
    status: 0,
    list: [],
    data: {
        result: [],
        additional: {}
    }
})
const state = initialState
 
const getters = {
    getMsg: state => state.msg,
    getStatus: state => state.status,
    getList: state => state.list || [],
    getData: state => state.data || {}
}

const actions = {
    async submit({
        commit
    }, {data,tapi_lecture_id}) {
        try {
            const url = `/tapi-result/${tapi_lecture_id}`
            const response = await postData(url,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async confirm({
        commit
    }, {data,id}) {
        try {
            const url = `/tapi-result/confirm/${id}`
            const response = await postData(url,data);
            commit('SET_RESPONSE', response.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async fetchData({
        commit
    }, tapi_lecture_id){
        try {
            const url = `/tapi-result/field/${tapi_lecture_id}`
            const response = await getDataWithParams(url);
            commit('SET_RESPONSE', response.data);
            commit('SET_LIST', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    async getReport({
        commit
    }, tapi_lecture_id){
        try {
            const url = `/tapi-result/report/${tapi_lecture_id}`
            const response = await getDataWithParams(url);
            commit('SET_RESPONSE', response.data);
            commit('SET_DATA', response.data.data);
        } catch (err) {
            if(err.response){
                commit('SET_FAILED_MESSAGE', err.response);
            }else{
                commit('SET_FAILED')
            }
        }
    },
    resetState({commit}){
        commit('resetState')
    }
}

const mutations = {
    SET_FAILED(state) {
        state.msg = 'Jaringan Bermasalah'
        state.status = 0
    },
    SET_FAILED_MESSAGE(state, error) {
        state.msg = error?.data?.msg || 'Jaringan Bermasalah'
        state.status = error?.data?.status || 0
    },
    SET_RESPONSE(state, response) {
        state.msg = response.msg
        state.status = response.status
    },
    SET_LIST(state, value){
        state.list = value
    },
    SET_DATA(state, value){
        state.data = value
    },
    resetState (state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}